import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withKeys as _withKeys, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "text-subtitle-1 text-medium-emphasis" }
const _hoisted_3 = { class: "text-subtitle-1 text-medium-emphasis d-flex align-center justify-space-between" }
const _hoisted_4 = { key: 1 }

import { computed, onMounted, ref } from 'vue'
import { doctorAuthStore } from '../../../../stores/doctor-auth'
import { useI18n } from 'vue-i18n'
import HeaderComponent from '@/components/Header/HeaderComponent.vue'
import { useRoute } from 'vue-router'
import { useMeta } from 'vue-meta'
import { hospitalAuthStore } from '@/stores/hospital-auth'


export default /*#__PURE__*/_defineComponent({
  __name: 'HospitalResetPassword',
  setup(__props) {

const { t } = useI18n()
const route = useRoute()
const password = ref<string>('')
const confirmPassword = ref<string>('')
const isLoading = ref(false)
const token = ref()
const docId = ref()
const responseStatus = ref({})

const passwordRules = [(v: string) => !!v || t('password-required')]
const passwordMatchingRule = [
  (v: string) => v == password.value || t('password-match'),
]
onMounted(() => {
  token.value = route.query.token
  docId.value = route.query.userId
})

const isInfoCompleted = computed(() => {
  const isPasswordInvalid = passwordRules.some((rule) => {
    const result = rule(password.value)
    return typeof result === 'string'
  })

  const passwordDoNotMatch = passwordMatchingRule.some((rule) => {
    const result = rule(confirmPassword.value)
    return typeof result === 'string'
  })

  return !isPasswordInvalid && !passwordDoNotMatch
})

useMeta(
  computed(() => ({
    title: 'Medcircle',
  }))
)

const resetPassword = async () => {
  isLoading.value = true
  const hospitalAuth = hospitalAuthStore()

  const credentials = {
    userId: docId.value,
    token: token.value,
    password: password.value,
  }
  const response = await hospitalAuth.resetPassword(credentials)
  responseStatus.value = response
  isLoading.value = false
}

return (_ctx: any,_cache: any) => {
  const _component_request_status = _resolveComponent("request-status")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_item = _resolveComponent("v-card-item")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(HeaderComponent),
    _createVNode(_component_request_status, {
      response: responseStatus.value,
      isLoading: false
    }, null, 8, ["response"]),
    _createVNode(_component_v_card, {
      class: "mx-auto pa-12 pb-8 my-15",
      elevation: "8",
      "max-width": "548",
      rounded: "lg"
    }, {
      default: _withCtx(() => [
        (!responseStatus.value.success)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('password')), 1),
              _createVNode(_component_v_text_field, {
                modelValue: password.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((password).value = $event)),
                density: "compact",
                placeholder: _ctx.$t('enter-password'),
                "prepend-inner-icon": "mdi-lock-outline",
                rules: passwordRules,
                variant: "outlined",
                onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (isInfoCompleted.value ? resetPassword() : undefined), ["enter"]))
              }, null, 8, ["modelValue", "placeholder"]),
              _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('re-password')), 1),
              _createVNode(_component_v_text_field, {
                modelValue: confirmPassword.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((confirmPassword).value = $event)),
                density: "compact",
                placeholder: _ctx.$t('enter-password'),
                "prepend-inner-icon": "mdi-lock-outline",
                rules: passwordMatchingRule,
                variant: "outlined",
                onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (isInfoCompleted.value ? resetPassword() : undefined), ["enter"]))
              }, null, 8, ["modelValue", "placeholder"]),
              _createVNode(_component_v_btn, {
                class: "mb-8",
                color: "blue",
                size: "large",
                variant: "flat",
                block: "",
                loading: isLoading.value,
                disabled: !isInfoCompleted.value,
                onClick: resetPassword
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('reset-password')), 1)
                ]),
                _: 1
              }, 8, ["loading", "disabled"])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_component_v_card_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_title, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('password-reset-title')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_card_text, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('password-reset-text')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_card_text, null, {
                    default: _withCtx(() => [
                      _createElementVNode("a", {
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$router.push('/hospital-login'))),
                        class: "text-blue text-decoration-none",
                        style: {"cursor":"pointer"}
                      }, _toDisplayString(_ctx.$t('login')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]))
      ]),
      _: 1
    })
  ], 64))
}
}

})